import React, { useState, useRef, useEffect } from "react";

import axios from 'axios';

import "./StudiesDropdown.css";
import RightArrow from "../../assets/RightArrow.svg";
import CheckMark from "../../assets/CheckMark.svg";
import DropdownOpen from "../../assets/DropdownOpen.svg";
import DropdownClose from "../../assets/DropdownClose.svg";

import { useLocation, useNavigate } from "react-router-dom";

import { toUrlComponent, fromUrlComponent, splitUrl, getSubUrlByIndices, getSubUrlAfterIndex  } from "../../utils/UrlUtils";

import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../context/store';
import { updateStudyInfo } from '../../context/studyInfoSlice';
import { updateStudy } from '../../context/studyMappingsSlice';

import { useSharedState } from '../../context/sharedState';

import { getIdToken } from "../../amplifyAPIs/authUtils";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const VERSION = process.env.REACT_APP_API_VERSION;

interface StudyDropdownProps {
}

type StudyInfo = {
  StudyOrg: string;
  StudyName: string;
};

interface OriginalStudy {
  type: string;
  label: string;
  study_name: string[];
  study_ids: number[];
}

/// Dynamic Studies Interface and API -----------------------------------------------------------

interface Study {
  type: string;
  label: string;
  studies?: string[]; 
}

// Need to write an api to get Study Data
const data: Study[] = [
  {
    type: "all",
    label: "All Studies",
    studies: [],
  },
  
];


// // Need to write an api to get Study Data
// const data: Study[] = [
//   {
//     type: "all",
//     label: "All Studies",
//     studies: [],
//   },
//   {
//     type: "organization",
//     label: "Organization A",
//     studies: ["Study A1", "Study A2", "Study A3"],
//   },
//   {
//     type: "organization",
//     label: "Organization B",
//     studies: ["Study B1"],
//   },
// ];

// --------------------------------------------------------------------------------------

const transformToStudies = (data: OriginalStudy[]): Study[] => {
  return data.map(org => ({
    type: "organization",
    label: org.label,
    studies: org.study_name
  }));
};

interface StudyMapping {
  [key: string]: {
    study_id: number;
    organization_name: string;
  };
}

const transformToStudyMap = (data: OriginalStudy[]): StudyMapping => {
  const result: StudyMapping = {};

  data.forEach(org => {
    org.study_name.forEach((name, index) => {
      if (index < org.study_ids.length) {  // Ensure there's a corresponding study_id
        result[name] = {
          study_id: org.study_ids[index],
          organization_name: org.label, 
        };
      }
    });
  });

  return result;
};



const StudyDropdown: React.FC<StudyDropdownProps> = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState(""); // This is the default page when the user logs in 
  const [startSearching, setStartSearching] = useState(false);

  const [studiesData, setStudiesData] = useState<Study []>(data)

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const { sharedState } = useSharedState();

  useEffect(() => {
    if(sharedState){
      setLoading(true);
    }else{
      setLoading(false);
    }
  } , [sharedState])

  const dispatch = useDispatch(); // Dispatcher to update study

  // let storeStudyMap = useSelector((state: RootState) => state.studyMapping);

  // useEffect(() => {
  //   console.log("HELLO : ", storeStudyMap)
  // }, [storeStudyMap])

  useEffect(() => {
    const fetchData = async () => {
      try {

        const idToken = await getIdToken();

        if (!idToken) {
          console.error("User is not authenticated");
          return;
        }

        console.log("Fetching Study Organisations and Studies Data")
        // Fetch data from the API
        const response = await fetch(`${BASE_URL}/getStudyOrgAndStudies`, {
          method: 'GET',
          // headers: {
          //   Authorization: `Bearer ${idToken}`,
          // },
        });

        if (!response.ok) {
          console.log('Failed to fetch data')
          console.log(response);
          throw new Error('Failed to fetch data');
        }
        const result = await response.json();
        console.log("Fetched Organizations and Study names!")

        // console.log(JSON.parse(result['body']));

        if(result['statusCode'] == 200){
          const newStudies: Study[] = transformToStudies(JSON.parse(result['body']));
          
          dispatch(updateStudy(transformToStudyMap(JSON.parse(result['body']))));
          // console.log("This is the transformed data",newStudies);

          const updatedData = [...data];
          newStudies.forEach(study => {
            updatedData.push(study);
          });
          setStudiesData(updatedData);
          handleStudyChange("All Studies", "All Studies");

          // console.log("Transformed Data: ", transformToStudyMap(JSON.parse(result['body'])))

          console.log("Updated Studies in Tab Bar")

        }else{
          // Show Error Loading Studies message
          const Error: Study[] = [
            {
              type: "all",
              label: "Error Loading Studies..",
              studies: [],
            },
            
          ];
          const updatedData = Error;
          setStudiesData(updatedData);
          handleStudyChange("Error Loading Studies..", "Error Loading Studies..");
        }

      } catch (error) {
        setError((error as Error).message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures it runs once on mount

  const toggleDropdown = () => {
    if (!isOpen) {
      setStartSearching(false); // Reset the startSearching flag when opening the dropdown
    }
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // const handleItemClick = (item: string, org: string) => {
  //   setSelectedItem(item);
  //   handleStudyChange(item, org);
  //   setSearchTerm(item); // Keep the search term in the input field after selection
  //   setIsOpen(false);    // Close the dropdown
  // };

  const handleItemClick = (item: string, org: string) => {
    handleStudyChange(item, org);
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    if (!isOpen) setIsOpen(true); // Open the dropdown if it's closed
    setStartSearching(true);      // Start searching/filtering when the user types
  };

  const filterItems = (items: Study[]) => {
    if (!startSearching) return items; // Show all items if startSearching is false

    return items.reduce((acc: Study[], item) => {
      const matchesOrganization = item.label
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const filteredStudies = item.studies?.filter((study) =>
        study.toLowerCase().includes(searchTerm.toLowerCase())
      );

      if (
        item.type === "all" ||
        matchesOrganization ||
        (filteredStudies && filteredStudies.length > 0)
      ) {
        acc.push({ ...item, studies: filteredStudies || [] });
      }

      return acc;
    }, []);
  };

  const filteredData = filterItems(studiesData).sort((a, b) =>
    a.type === "all" ? -1 : 0
  );


  /// State Management of Studies part ------------------------------------------------------------------

  const handleStudyChange = (studyName: string, org: string) => {

    let newStudy : StudyInfo = {
      StudyOrg: "",
      StudyName: ""
    };
    
    if(studyName == org){
      newStudy = {
        StudyOrg: org,
        StudyName: ""
      }
    }else{
      newStudy = {
        StudyOrg: org,
        StudyName: studyName
      }
    }
    
    dispatch(updateStudyInfo(newStudy));
  
    // console.log("Study in Store", storeStudy);

  };

  // --------------------------------------------------------------------------------------------

  let storeStudy = useSelector((state: RootState) => state.studyInfo);

  useEffect(() => {
    
    // const storeStudy = useSelector((state: RootState) => state.studyInfo);
    let StudyOrg = storeStudy.study.StudyOrg
    let StudyName = storeStudy.study.StudyName

    if (StudyOrg && StudyName == ""){

      setSelectedItem(StudyOrg);
      setSearchTerm(StudyOrg);
      setIsOpen(false); 
    } else if (StudyName && StudyOrg) {

      setSelectedItem(StudyName);
      setSearchTerm(StudyName);
      setIsOpen(false); 
    } else {

      setSelectedItem("All-Studies");
      setSearchTerm("All-Studies");
      setIsOpen(false); 
    }

    // console.log("Store values: ", StudyOrg, " ", StudyName);

  }, [storeStudy]);

  // Organization and Study Names should not consist of hyphens or punctuation marks - only spaces 

  // So what i need to do is 
  // 1. Store the study as a state in State Management
  // 2. Also store the study in the query parameters (This is for convenience) - redirection incase user logins through url
  // 3. 


  // Write function that will beautify the text of studies and organization - for now consider now all hyphenated


  // {
  //   participantDetails: {
  //     AnomalousData: [ type SensorDetails],
  //     StableData: [type SensorDetails],
  //     UnassignedData: [type SensorDetails]
  //   },
  //   sensorDetails :{
  //     AttachedData: [ type SensorDetails],
  //     AttachedData: [type SensorDetails],
  //   }
  // }



  return (
    <div className={`dropdown-container ${loading ? 'disabled' : ''}`} ref={dropdownRef}>
      <div className={`dropdown-header ${isOpen ? "isOpen" : ""} ${loading ? 'disabled' : ''}`} onClick={toggleDropdown}>
        <input
          type="text"
          value={searchTerm}
          placeholder="Select an option"
          onChange={handleSearch}
          onClick={(e) => {
            e.stopPropagation();
            if (!isOpen) setIsOpen(true); // Open the dropdown if it's closed
          }}
        />
        <img
          src={isOpen ? DropdownOpen : DropdownClose}
          alt="Toggle Dropdown"
          className="icon"
        />
      </div>
      {isOpen && (
        <div className="dropdown-list no-border">
          {filteredData.map((item, index) => (
            <React.Fragment key={index}>
              <div
                className={`dropdown-item ${
                  item.type === "organization" ? "organization-item" : ""
                } ${selectedItem === item.label ? "selected-item" : ""}`}
                onClick={() => handleItemClick(item.label, item.label)}
              >
                <span>{item.label}</span>
                {selectedItem === item.label && (
                  <img
                    src={CheckMark}
                    alt="Selected"
                    className={`checkmark-icon ${
                      item.type === "all" ? "checkmark-icon-all-studies" : ""
                    }`}
                  />
                )}
                {item.type === "organization" && (
                  <img
                    src={RightArrow}
                    alt="Arrow"
                    className="arrow-icon"
                  />
                )}
              </div>
              {item.type === "organization" && item.studies && (
                <div className="organization-studies">
                  {item.studies.map((study, idx) => (
                    <div
                      key={idx}
                      className={`dropdown-item nested-item ${
                        selectedItem === study ? "selected-item" : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleItemClick(study, item.label);
                      }}
                    >
                      <div className="nested-text">{study}</div>
                      {selectedItem === study && (
                        <img
                          src={CheckMark}
                          alt="Selected"
                          className="checkmark-icon"
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
              {index < filteredData.length - 1 && (
                <div className="divider"></div>
              )}
            </React.Fragment>
          ))}
          {!filteredData.length && (
            <div className="dropdown-item no-results">
              No studies found.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StudyDropdown;
